module.exports = __webpack_public_path__ + "img/cover1.190a7e0c.webp";